import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init(
    {
      fallbackLng: "en",
      ns: [
        "login",
        "common",
        "fuse",
        "tests",
        "fuseUpdates",
        "analyserUpdates",
      ],
      defaultNS: "common",
      debug: false,
      detection: {
        order: ["queryString", "cookie"],
        cache: ["cookie"],
      },
      interpolation: {
        escapeValue: false,
      },
    },
    (err, t) => {
      if (err) {
        return console.log("something went wrong loading", err);
      }
      t("key");
    }
  );

export default i18n;
